import { ref, createApp, onMounted } from 'vue';
import common from '@page/common/js/common';
import slick from 'slick-carousel';

import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import SortApp from '@page/shop/components/SortApp.vue';
import Pagination from '@global/components/common/pagination/PaginationLayout.vue';

import fireShopListViewEvent from '@global/gtm/shopList/shopListView';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';
import $ from 'jquery';

$(document).ready(function () {
  const $header = $('#page-shop .header');
  const headerHight = $header.height();

  if ($header.length < 1) return;

  function windowSize() {
    if ($(window).width() < 1200) {
      return true;
    }
  }

  $(window).resize(function () {
    windowSize();
  });

  let isMobile = windowSize();

  $(window).scroll(function () {
    if (!isMobile) {
      $(window).scrollTop() > headerHight
        ? $header.addClass('active')
        : $header.removeClass('active');
    }
  });
});

const app = createApp({
  components: {
    SortApp,
    Pagination,
  },
  setup() {
    const { getSortConditionAPI } = useAxiosAPI();

    const largeMode = ref(false);
    const sortConditionDatas = ref(null);
    const sortConditionIsLoad = ref(false);
    const bannerSliderConfig = ref({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 6000,
    });

    function fireGTM(customMarketID, size) {
      fireShopListClickGTMEvent({ customMarketID, size });
    }

    function getSortCondition() {
      getSortConditionAPI()
        .then((res) => {
          if (res.data.Code === 200) {
            sortConditionDatas.value = res.data.Response;
            sortConditionIsLoad.value = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    fireShopListViewEvent();
    getSortCondition();

    onMounted(() => {
      if ($('.banner-slide').length) {
        $('.banner-slide').slick(bannerSliderConfig.value);
      }
      if ($('.item-box').length > 3) {
        $('#category-sidebar').stick_in_parent({ offset_top: 200 });
      }
    });

    return {
      largeMode,
      sortConditionDatas,
      sortConditionIsLoad,
      fireGTM,
    };
  },
});

app.mount('#app-shop');
